import React from "react";
import ForecastBatchRouter from './Batch/Router';
export { getFields } from './Batch/Router';

export default function CostBatchForecastRouter(props) {
    return (
        <ForecastBatchRouter {...props} />
    );
};